import { SET_SHOP } from '../actionTypes';

const setShop = shop => ({
  type: SET_SHOP,
  payload: {
    shop,
  },
});

export default setShop;
